"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var url_helpers_1 = require("../components/shared/url_helpers");
var ConvertShopTypeRoute = (React.createElement(react_router_1.Route, { key: url_helpers_1.default.convertShopTypePath, path: url_helpers_1.default.convertShopTypePath, getComponent: function (location, cb) {
        require.ensure([], function (require) {
            cb(null, require('../onboarding/legacy/convert_shop_type_container').default);
        }, 'onboarding');
    } },
    React.createElement(react_router_1.IndexRoute, { getComponent: function (location, cb) {
            require.ensure([], function (require) {
                cb(null, require('../onboarding/legacy/convert_shop_type_form').default);
            }, 'onboarding');
        } }),
    React.createElement(react_router_1.Route, { key: url_helpers_1.default.convertShopTypeFinishPath, path: url_helpers_1.default.convertShopTypeFinishPath, getComponent: function (location, cb) {
            require.ensure([], function (require) {
                cb(null, require('../onboarding/legacy/convert_shop_type_complete').default);
            }, 'onboarding');
        } })));
exports.default = ConvertShopTypeRoute;
//# sourceMappingURL=convert_shop_type.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/routes/convert_shop_type.js
// module id = O8zp
// module chunks = 20 21